import PackageForm from './package-form/PackageForm';
import { PACKAGE_STATUS_ACTIVE } from '.';
import { useAuthContext } from 'context/authContext';
import { useNavigate } from 'react-router-dom';
import paths from 'routes/paths';
import { useCreatePackage } from 'hooks/useDonationSettings';

function CreatePackage() {
  const navigate = useNavigate();
  const { organization } = useAuthContext();
  const { createPackage, isCreating: loading } = useCreatePackage();

  const onSubmit = async (data) => {
    try {
      await createPackage({
        ...data,
        organisation_id: organization.id,
        status: PACKAGE_STATUS_ACTIVE
      });
      navigate(paths.donationPackages);
    } catch (error) {
      console.error(error);
    }
  };

  return <PackageForm onSubmit={onSubmit} loading={loading} />;
}

export default CreatePackage;
